import { render, staticRenderFns } from "./InvestorBody.vue?vue&type=template&id=1dc17e02"
import script from "./InvestorBody.vue?vue&type=script&lang=js"
export * from "./InvestorBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports